export default class Inventaro {
	constructor(
		$scope,
		ubicacionService,
		inventarioService,
		$location,
		$routeParams,
		method,
		tipoEquipoService,
		estadoEquipoService,
		columnasService,
		proveedorService,
		Upload,
		imageService,
		marcasService,
		proyectosService,
		$uibModal,
		tipoFallaService,
		baseUrl,
		tipoOperacionService,
		causaFallaService,
		objetoUbicacionService,
		tipoUbicacionesService,
		clientesService,
		toastr,
		info,
		$route,
		filtros
	) {

		this.scope = $scope;
		this.location = $location;
		this.uibModal = $uibModal;
		this.baseUrl = baseUrl;
		this.scope.baseUrl = baseUrl;
		this.toastr = toastr;
		this.scope.info = info;
		this.scope.route = $route;

		this.scope.handleDisplayFilters = this.handleDisplayFilters.bind(this);
		this.scope.displayFilters = false;
		this.scope.cliente = localStorage.getItem('cliente');
		var self = this;

		this.scope.aux = {
			filters: {},
			query: {}
		};	
				
		this.scope.aux.columnas = columnasService.getColumnasInventario(localStorage.getItem('cliente'));
		console.log(this.scope.aux.columnas);

		this.scope.$watch("info.get('permisos')", function (newVal) {
			console.log(newVal)
			if (angular.isDefined(newVal.eq)) {
				self.scope.readOnly = !newVal.eq.w;
			}
		});

		switch (method) {
			case 'list':
				this.list(ubicacionService,
					inventarioService,
					tipoEquipoService,
					estadoEquipoService,
					clientesService,
					proyectosService,
					columnasService,
					filtros);
				break;

			case 'view':
				this.view($routeParams,
					inventarioService,
					ubicacionService,
					tipoEquipoService,
					estadoEquipoService,
					proveedorService,
					imageService,
					marcasService,
					proyectosService,
					tipoFallaService,
					Upload,
					tipoOperacionService,
					causaFallaService,
					objetoUbicacionService,
					tipoUbicacionesService,
					toastr
				);
				break;

			case 'new':
				this.create(inventarioService,
					ubicacionService,
					tipoEquipoService,
					estadoEquipoService,
					proveedorService,
					Upload,
					marcasService,
					proyectosService,
					tipoOperacionService,
					objetoUbicacionService,
					tipoUbicacionesService
				);
				break;

			case 'ubicacion':
				this.scope.filtro = {
					ubicacion: '',
					subUbicacion: ''
				}
				this.ubicacion(ubicacionService, inventarioService);
				break;

			case 'ubicacion-tipo':
				this.ubicacionTipo($routeParams, inventarioService);
				break;

			case 'completar_list':
				this.list_completar(ubicacionService,
					inventarioService,
					tipoEquipoService,
					estadoEquipoService);
				break;

			case 'completar_view':
				this.view_completar($routeParams,
					inventarioService,
					ubicacionService,
					tipoEquipoService,
					estadoEquipoService,
					proveedorService,
					imageService,
					marcasService,
					proyectosService,
					tipoFallaService,
					Upload,
					tipoOperacionService,
					causaFallaService,
					objetoUbicacionService,
					tipoUbicacionesService);
				break;

			case 'carga':
				this.carga(Upload);
				break;
		}
		this.scope.nombre = 'inventario controller';
	}

	list(ubicacionService,
		inventarioService,
		tipoEquipoService,
		estadoEquipoService,
		clientesService,
		proyectosService,
		columnasService,
		filtros) {

		this.scope.sortType = "numero_serie";
		this.scope.sortReverse = false;	
		
		this.scope.aux.filters = filtros.inventario;

		let arWatch = ['aux.filters.tipo', 'aux.filters.estado', 'aux.filters.subparte', 'aux.filters.ubicacion', 'aux.filters.cliente', 'aux.filters.proyecto'];
		this.scope.$watchGroup(arWatch, (nuevo) => {
			let filtro = {};
			for (var el in nuevo) {
				let element = nuevo[el];
				if (element) {
					if (element._id) {
						if (element.tipo_p) {
							filtro[element.tipo_p] = element._id;
						} else {
							filtro[element.nombre_interno] = element._id;
						}
					} 
					else {
						filtro[element.tipo_p] = element.valor;
					}
				}
			}

			this.scope.aux.query = filtro;
			inventarioService.getAll(filtro)
				.then((resp, err) => {
					if (!err) {
						this.scope.aux.equipos = resp.data.message;
					} else {
						console.log(err);
					}
				});
		});

		tipoEquipoService.getAll()
			.then((resp) => {
				let r = resp.data.message;
				for (var el in r) {
					let element = r[el];
					element.tipo_p = "tipo_equipo._id"
				}
				this.scope.aux.filters.tipos = r;
			});

		estadoEquipoService.getAll()
			.then((resp) => {
				let r = resp.data.message;
				for (var el in r) {
					let element = r[el];
					element.tipo_p = "estado._id";
				}
				this.scope.aux.filters.estados = r;
			});

		ubicacionService.getAll({ "tipo.flag_equipos": true })
			.then((resp) => {

				// console.log(resp);
				let data = resp.data.message.map((el) => {
					let ubicacion_ar = [];
					ubicacion_ar.push(el.nombre);

					let tiene_padre = true;
					let puntero = el;

					while (tiene_padre) {
						if (puntero.hasOwnProperty('padre')) {
							ubicacion_ar.push(puntero.padre.nombre);
							puntero = puntero.padre;
						} else {
							tiene_padre = false;
						}
					}

					return {
						_id: el._id,
						nombre: ubicacion_ar.reverse().join('/ '),
						nombre_interno: 'ubicacion.' + el.tipo.nombre_interno + '._id'
					};
				});

				this.scope.aux.filters.ubicaciones = data;
			});

		clientesService.getAll()
			.then((resp) => {
				let r = resp.data.message;
				for (var el in r) {
					let element = r[el];
					element.tipo_p = "proyecto.cliente._id";
				}
				this.scope.aux.filters.clientes = r;
			});

		this.scope.$watch('aux.filters.cliente', (nuevo) => {
			if (nuevo) {
				let filter = {
					'cliente._id': nuevo._id
				};

				proyectosService.getAll(filter)
					.then((resp) => {
						console.log(resp);
						let r = resp.data.message;
						for (var el in r) {
							let element = r[el];
							element.tipo_p = "proyecto._id";
						}
						this.scope.aux.filters.proyectos = r;
					});
			} else {
				this.scope.aux.filters.proyectos = [];
			}
		});

		let dataSub = [{
			nombre: "Si",
			tipo_p: 'tipo_equipo.sub_parte',
			valor: true
		}, {
			nombre: "No",
			tipo_p: 'tipo_equipo.sub_parte',
			valor: false
		}];
		this.scope.aux.filters.subpartes = dataSub;

		this.scope.getUbicacion = (ub) => {
			let resp = '';
			for (var el in ub) {
				let element = ub[el].nombre;
				resp += element + '/ ';
			}
			return resp;
		};

		this.scope.showInventario = (inventario) => {
			this.location.path('/inventario/' + inventario._id);
		};

		this.scope.descargarExcel = this.descargarExcel.bind(this);
	}

	descargarExcel() {
		// console.log(this.scope.aux.query);
		let extra = '&string=' + JSON.stringify(this.scope.aux.query);
		var url = window.location;
		var urlNew = this.scope.baseUrl + '/api/inventario/excel' + '?token=' + localStorage.getItem('token') + extra;
		window.open(urlNew);
	}

	view($routeParams,
		inventarioService,
		ubicacionService,
		tipoEquipoService,
		estadoEquipoService,
		proveedorService,
		imageService,
		marcasService,
		proyectosService,
		tipoFallaService,
		Upload,
		tipoOperacionService,
		causaFallaService,
		objetoUbicacionService,
		tipoUbicacionesService,
		toastr
	) {

		this.inventarioService = inventarioService;

		var index = location.hash.indexOf('?');;
		var path = location.hash.substr(index + 1);
		var index2 = path.indexOf('=');
		var valor = path.substr(index2 + 1);

		if (valor.indexOf('/') < 0 && path.indexOf('incidencia') > -1) {
			this.scope.incidencia = valor;
		} else if (valor.indexOf('/') < 0 && path.indexOf('ott') > -1) {
			this.scope.ott = valor;
		}

		this.scope.verIncidencia = () => {
			this.location.path('incidencia/' + this.scope.incidencia);
		}

		this.scope.verOtt = () => {
			this.location.path('ott/' + this.scope.ott);
		}

		this.scope.tipo_operaciones = [
			"manual",
			"remota"
		];

		this.scope.aux = {};
		this.scope.aux.selects = {};
		this.scope.aux.token = localStorage.getItem('token');

		let garantia_obj = function (obj) {
			obj.inicio = moment(obj.inicio).format('DD-MM-YYYY, h:mm a');
			obj.fin = moment(obj.fin).format('DD-MM-YYYY, h   :mm a');
			return obj;
		};

		tipoOperacionService.getAll().then((resp, err) => {
			this.scope.aux.tipo_operaciones = resp.data.message;
		});

		tipoEquipoService.getAll().then((resp, err) => {
			this.scope.tipo_equipos = resp.data.message;
		});

		estadoEquipoService.getAll().then((resp, err) => {
			this.scope.estado_equipos = resp.data.message;
		});

		proveedorService.getAll().then((resp, err) => {
			this.scope.proveedores = resp.data.message;
		});

		marcasService.getAll({ "grupo": 'equipo' })
			.then((resp, err) => {
				this.scope.aux.marcas = resp.data.message;
			});

		inventarioService.getById($routeParams).then((resp, err) => {

			this.scope.equipo = resp.data.message;
			this.scope.equipo_original = angular.copy(this.scope.equipo);
			this.scope.aux.duenos = [this.scope.equipo.proyecto];

			let keys_ubicacion = Object.keys(this.scope.equipo.ubicacion);

			if (this.scope.equipo.ubicacion[keys_ubicacion[0]].objeto_ubicacion.flag_receptor) {
				this.scope.aux.flag_receptor = true;
			}

			this.scope.aux.equipo = JSON.parse(JSON.stringify(resp.data.message));
			this.scope.aux.fecha_instalacion = moment(this.scope.equipo.fecha_instalacion).format('DD-MM-YYYY, h:mm a');

			this.scope.aux.garantia_cliente = {};
			this.scope.aux.garantia_fabricante = {};
			if (typeof this.scope.equipo.garantia_cliente !== 'undefined') {
				let garantia_cliente = JSON.parse(JSON.stringify(this.scope.equipo.garantia_cliente));
				this.scope.aux.garantia_cliente = garantia_obj(garantia_cliente);
			}
			if (typeof this.scope.equipo.garantia_fabricante !== 'undefined') {
				let garantia_fabricante = JSON.parse(JSON.stringify(this.scope.equipo.garantia_fabricante));
				this.scope.aux.garantia_fabricante = garantia_obj(garantia_fabricante);
			}


			if (this.scope.equipo.imagen_id) {
				imageService.getById({ id: this.scope.equipo.imagen_id }).then((resp, err) => {
					this.scope.image = resp.data.data;
				});
			}

			this.scope.aux.equipos_padre = [this.scope.equipo.padre];

			this.ubicaciones(ubicacionService);
		});


		this.ubicaciones = (ubicacionService) => {
			let aux = this.scope.equipo.ubicacion;
			let order = [];
			for (var el in aux) {
				order.push(aux[el]);
				this.scope.aux.selects[(aux[el].tipo.nombre_interno + 's')] = [aux[el]];
			}
			this.scope.aux.tipo_ubicaciones = order;
		}

		this.scope.$watch('equipo.subparte', (nuevo) => {
			if (nuevo !== undefined && nuevo) {
				let ubicacion = this.scope.equipo.ubicacion.ubicacion._id;
				let proyecto = this.scope.equipo.proyecto._id;
				let filter = {
					'ubicacion.ubicacion': ubicacion,
					'subparte': false,
					'proyectos': proyecto
				};
				inventarioService.getAll(filter)
					.then((resp, errp) => {
						this.scope.aux.equipos_padre = resp.data.message;
					});
			}
		});

		this.scope.uploadFiles = ($file, $invalidFiles) => {
			this.scope.archivo = $file;
			this.addFile(Upload);
		};

		this.scope.actualizarEquipo = this.actualizarEquipo.bind(this, inventarioService, toastr);
		this.scope.agregarMovimiento = this.agregarMovimiento.bind(this, proyectosService, ubicacionService, objetoUbicacionService, tipoUbicacionesService);
		this.scope.registrarFalla = this.registrarFalla.bind(this, tipoFallaService, causaFallaService);
		this.scope.addAtributte = this.addAtributte.bind(this, inventarioService);
		this.scope.descargarPdf = this.descargarPdf.bind(this, inventarioService)
	}

	descargarPdf(inventarioService) {
		let data = {
			_id: this.scope.equipo._id
		}
		inventarioService.pdf(data)
			.then((resp) => {

				var url = window.location;
				var urlNew = this.baseUrl + '/api/ott/pdf/' + resp.data.nombre + '?token=' + localStorage.getItem('token');
				window.open(urlNew);
			});
	}

	list_completar(ubicacionService,
		inventarioService,
		tipoEquipoService,
		estadoEquipoService) {

		this.scope.aux = {
			filters: {},
			query: {}
		};

		inventarioService.list_completar({})
			.then((resp, err) => {
				if (!err) {
					this.scope.equipos = resp.data;
				} else {
					console.log(err);
				}
			});
	}

	view_completar($routeParams,
		inventarioService,
		ubicacionService,
		tipoEquipoService,
		estadoEquipoService,
		proveedorService,
		imageService,
		marcasService,
		proyectosService,
		tipoFallaService,
		Upload,
		tipoOperacionService,
		causaFallaService,
		objetoUbicacionService,
		tipoUbicacionesService) {

		this.upload = Upload;

		this.scope.aux = {
			selects: {}
		};

		this.scope.equipo = {
			ubicacion: {},
			garantia_cliente: {},
			garantia_fabricante: {},
			atributos: []
		};

		let find = {
			id: $routeParams.id
		}

		inventarioService.view_completar(find)
			.then((resp, er) => {
				if (!er) {

					let tipo_equipo_filter = {
						id_dinac: resp.data[0].tipo_equipo
					}

					tipoEquipoService.getAll(tipo_equipo_filter)
						.then((resp, err) => {
							console.log(resp);
							this.scope.aux.tipo_equipos = [resp.data.message[0]];
						});
				}
			});


		tipoOperacionService.getAll().then((resp, err) => {
			this.scope.aux.tipo_operaciones = resp.data.message;
		});

		proveedorService.getAll().then((resp, err) => {
			if (!err) {
				this.scope.aux.proveedores = resp.data.message;
			}
		});

		marcasService.getAll({ "grupo": 'equipo' })
			.then((resp, err) => {
				this.scope.aux.marcas = resp.data.message;
			});

		proyectosService.getAll()
			.then((resp, err) => {
				this.scope.aux.duenos = resp.data.message;
			});

		objetoUbicacionService.getAll()
			.then((resp) => {
				this.scope.aux.objeto_ubicaciones = resp.data.message;
			});

		this.scope.$watch('equipo.objeto_ubicacion', (nuevo) => {
			if (nuevo !== undefined) {
				this.scope.aux.flag_receptor = nuevo.flag_receptor;

				let filter = {
					"objeto_ubicacion._id": nuevo._id
				};

				tipoUbicacionesService.getAll(filter)
					.then((resp) => {
						this.scope.aux.tipo_ubicaciones = resp.data.message;
						// esta es la primera llamada y es manual
						// el indice 50 es el padre de todos los tipos
						let filter = {
							'tipo.indice': 50,
							'objeto_ubicacion._id': nuevo._id
						};
						ubicacionService.getAll(filter).
							then((resp, err) => {
								if (!err) {
									if (resp.data.message.length == 0) {
										alert('La estructura de este objeto no esta definida');
									}
									let index = this.scope.aux.tipo_ubicaciones[0].nombre_interno + 's';
									this.scope.aux.selects[index] = resp.data.message;
								}
							});
						ubicaciones()
					});
			}
		});

		var ubicaciones = () => {
			let data = this.scope.aux.tipo_ubicaciones;
			// este restringe el tipo de equipo en la ubicacion
			let arCollection = ['equipo.tipo_equipo'];
			for (var el in data) {
				let aux = data[el];

				let str = 'equipo.ubicacion.' + aux.nombre_interno;
				if (aux.flag_equipos) {
					arCollection.push(str);
				}
				// le agregamos el watch a los inputs
				this.scope.$watch(str, (nuevo) => {
					if (nuevo !== undefined && nuevo !== null && !nuevo.tipo.flag_equipos) {
						var filter = {
							"tipo.indice": nuevo.tipo.indice - 1,
							"padre._id": nuevo._id
						}

						// si es penultimo tenemos que hacer las siguientes valid.
						if (aux.flag_penultimo && !this.scope.equipo.tipo_equipo.sub_parte) {
							filter.$or = [
								{
									"tipo_equipo._id": this.scope.equipo.tipo_equipo._id,
									"tipo_equipo.flag_disponible": true
									// $elemMatch: {
									// _id : this.scope.equipo.tipo_equipo._id,
									// disponible: true
									// {
									// 	$gt: 0
									// }
									// }
									// }
								},
								{
									"objeto_ubicacion.flag_receptor": true
								}
							]
						}

						if (aux.flag_penultimo && this.scope.equipo.tipo_equipo.sub_parte) {
							filter.$or = [
								{
									"objeto_ubicacion.flag_receptor": this.scope.aux.flag_receptor
								}
							];
							// {
							// 	"tipo_equipo._id" = this.scope.equipo.tipo_equipo.padre[0]._id
							// },
						}

						let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

						ubicacionService.getAll(param)
							.then((resp) => {
								let data = resp.data.message;
								if (data.length == 0) {
									alert("No existen ubicaciones dentro de la seleccionada");
								} else {
									let ind = data[0].tipo.nombre_interno + 's';
									this.scope.aux.selects[ind] = data;
								}
							});
					}
				});
			}

			this.scope.$watchGroup(arCollection, (newValues, oldValues) => {
				let todoOk = true;
				for (var el in newValues) {
					if (!newValues[el]) {
						todoOk = false;
					}
				}

				if (todoOk && this.scope.equipo.tipo_equipo.sub_parte && !this.scope.aux.flag_receptor) {
					let padreIds = [];

					for (var i = 0; i < this.scope.equipo.tipo_equipo.padre.length; i++) {
						padreIds.push(this.scope.equipo.tipo_equipo.padre[i]._id);
					}

					let ubicacionAux = this.scope.equipo.ubicacion;
					let keyMin = '';
					let indMin = 50;
					let idMin = '';
					for (var el in ubicacionAux) {
						let element = ubicacionAux[el];
						if (element.tipo.indice < indMin) {
							indMin = element.tipo.indice;
							keyMin = el;
						}
					}
					idMin = ubicacionAux[keyMin]._id;

					let proyecto = this.scope.equipo.proyecto._id;
					let filter = {
						'ubicacion.ubicacion._id': idMin,
						'tipo_equipo.sub_parte': false,
						'proyecto._id': proyecto,
						'tipo_equipo._id': {
							"$in": padreIds
						}
					};

					inventarioService.getAll(JSON.stringify(filter))
						.then((resp, errp) => {
							if (resp.data.message.length == 0) {
								alert("No existen equipos disponibles en esta ubicación");
							} else {
								this.scope.aux.equipos_padre = resp.data.message;
							}
						});
				}
			});

		};

		// let arCollection = ['equipo.tipo_equipo', 'equipo.ubicacion.ubicacion'];
		this.scope.uploadFiles = ($file, $invalidFiles) => {
			this.scope.imagen = $file;
		};

		this.scope.guardar = () => {
			this.upload.upload({
				url: this.baseUrl + '/api/inventario',
				data: {
					imagen: this.scope.imagen,
					equipo: angular.toJson(this.scope.equipo)
				}
			}).then((resp) => {
				inventarioService.pre_equipo_delete({ id: $routeParams.id })
					.then((resp_del) => {
						console.log('eliminado');
						// this.location.path('/inventario/' + resp.data.message);
					});
			}).catch((er) => {
				console.log(er);
			});
		};

		this.scope.addAtributte = this.addAtributte.bind(this, inventarioService);
	}

	actualizarEquipo(inventarioService, toastr) {
		if (angular.toJson(this.scope.equipo) !== angular.toJson(this.scope.equipo_original)) {

			let templateModal = `
				<!-- Modal content-->
    			<div class="modal-content">
      				<div class="modal-header">
      					<h4 style="text-align:center;" class="modal-title">Ingresa un comentario</h4>
      				</div>
      				<div class="modal-body">
				        <input class="form-control" ng-model="comentario">
				    </div>
				    <div class="modal-footer">
				        <div class="btn btn-danger" ng-click="mv.close(false)">Cerrar</div>
						<div class="btn btn-success pull-right" ng-click="mv.close(true, comentario)">Agregar</div>
				    </div>
      			</div>
			`;

			var modal = this.uibModal.open({
				animation: true,
				ariaLabelledBy: 'modal-title',
				// ariaDescribedBy: cambios[i].path[0],
				template: templateModal,
				controller: function () {

					this.close = function (input, comentario) {

						if (typeof comentario === 'undefined' || comentario.trim() == '') {
							toastr.error('Debe ingresar un comentario!', 'Error!', {
								timeOut: 2000,
								closeButton: true
							});
							return false;
						}

						modal.close({
							input: input,
							comentario: comentario,
							campo: this.campo,
							valor: this.valor,
							// index: modalIndex
						});
					}
				},
				controllerAs: 'mv',
				size: 'md',
				resolve: {
				}
			});

			modal.result.then((respuesta) => {

				if (respuesta.input) {
					let data = {
						"fecha": new Date(),
						"mensaje": 'Actualización equipo',
						"comentario": respuesta.comentario,
						"usuario": this.scope.info.get('nombre') + ' ' + this.scope.info.get('apellido')
					};


					this.scope.equipo.historial.push(data);
					// console.log(this.scope.equipo);
					inventarioService.update(this.scope.equipo)
						.then((resp, err) => {
							toastr.success('Equipo modificado correctamente!', 'Success!', {
								timeOut: 2000,
								closeButton: true
							});
							this.location.path('/inventario/general');
						});
				}
			}, () => {
				// console.log('Modal dismissed at: ' + new Date());
			});

		} else {
			toastr.warning('No se ha realizado algun cambio', 'Informacion', {
				timeOut: 2000,
				closeButton: true
			});
		}
	}

	agregarMovimiento(proyectosService, ubicacionService, objetoUbicacionService, tipoUbicacionesService) {

		let templateModal = `
			<div class="modal-content">
				<h4 style="text-align:center;" class="modal-title">Cambiar ubicación del equipo</h4>
			</div>
			<div class="modal-body">
				<div class="form-horizontal form-label-left">
					<div class="form-group">
						<label class="control-label col-md-5 col-sm-5 col-xs-12" for="last-name">Objeto Ubicación<span class="required">*</span>
						</label>
						<div class="col-md-7 col-sm-7 col-xs-12">
							<select class="form-control"
								name="proyecto" ng-disabled="vm.aux.objeto_ubicaciones.lenght == 0"
								ng-model="mv.aux.objeto_ubicacion" ng-disabled="aux.selects[(el.nombre_interno + 's')].lenght == 0"
								ng-options="obj as obj.nombre for obj in mv.aux.objeto_ubicaciones | orderBy:'nombre' track by obj._id">
							</select>
						</div>
					</div>

					<div ng-repeat="el in mv.aux.tipo_ubicaciones">
						<div class="form-group">
							<label class="control-label col-md-5 col-sm-5 col-xs-12" for="first-name">{{el.nombre}} <span class="required">*</span>
							</label>
							<div class="col-md-7 col-sm-7 col-xs-12">
								<select
									class="form-control" ng-if="$first"
									name="ubicacion" ng-model="mv.models[el.nombre_interno]"
									ng-options="op as op.nombre for op in mv.aux.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
								</select>

								<select class="form-control" ng-if="!$first"
									ng-model="mv.models[el.nombre_interno]"
									ng-options="op as op.nombre for op in mv.aux.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
								</select>
							</div>
						</div>
					</div>
				</div>
		    </div>
		    <div class="modal-footer">
				<div class="btn btn-success pull-right" ng-click="mv.cerrar()">Aceptar</div>
			</div>
		`;

		let self = this.scope;

		var modal = this.uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: '',
			template: templateModal,
			controller: function (proyecto, ubicacionService, scope, ubicacionActual, objetoUbicacionService, tipoUbicacionesService) {

				var mv = this;
				mv.aux = {
					selects: {}
				};
				mv.models = {};

				this.main = function () {

					let filter = {
						"proyectos._id": scope.equipo.proyecto._id
					};

					objetoUbicacionService.getAll(filter)
						.then((resp) => {
							mv.aux.objeto_ubicaciones = resp.data.message;
						}).catch((er) => {
							console.log(er);
						});

					var watchTramo = function (scope) {
						return mv.aux.objeto_ubicacion;
					};

					scope.$watch(watchTramo, (nuevo) => {
						if (nuevo !== undefined) {
							let filter = {
								"objeto_ubicacion._id": nuevo._id
							};

							tipoUbicacionesService.getAll(filter)
								.then((resp) => {
									mv.aux.tipo_ubicaciones = resp.data.message;
									let aux = resp.data.message[0];

									let filter = {
										"objeto_ubicacion._id": aux.objeto_ubicacion._id,
										"tipo.flag_hijo": false
									}

									ubicacionService.getAll(filter)
										.then((resp) => {
											mv.aux.selects[(aux.nombre_interno + 's')] = resp.data.message;
										});

									this.ubicaciones();
								});
						}
					});
				}

				this.ubicaciones = () => {
					let data = mv.aux.tipo_ubicaciones;
					// 'equipo.ubicacion.ubicacion'
					let arCollection = ['equipo.tipo_equipo'];
					for (var el in data) {
						let aux = data[el];
						let str = 'mv.models.' + aux.nombre_interno;

						if (aux.flag_equipos) {
							arCollection.push(str);
						}

						let getModel = () => {
							return mv.models[aux.nombre_interno];
						}

						scope.$watch(getModel, (nuevo) => {
							if (nuevo !== undefined && !nuevo.tipo.flag_equipos) {
								var filter = {
									"tipo.indice": nuevo.tipo.indice - 1,
									"padre._id": nuevo._id
								}

								if (aux.flag_penultimo) {
									filter.$or = [
										{
											tipo_equipos: {
												$elemMatch: {
													_id: scope.equipo.tipo_equipo._id,
													disponible: {
														$gt: 0
													}
												}
											}
										},
										{
											"padre._id": nuevo._id,
											"tipo.flag_bodega": true
										}
									]
								}

								let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

								ubicacionService.getAll(param)
									.then((resp) => {
										let data = resp.data.message;
										if (data.length == 0) {
											alert("No existen ubicaciones dentro de la seleccionada");
										} else {

											if (data[0].tipo.flag_equipos) {
												let dataFilter = [];
												let ubActual = { id: 0, indice: 100 };

												for (var el in scope.equipo.ubicacion) {
													let elemento = scope.equipo.ubicacion[el];
													if (elemento.tipo.indice < ubActual.indice) {
														ubActual.indice = elemento.tipo.indice;
														ubActual.id = elemento._id;
													}
												}

												for (var el in data) {
													let elemento = data[el];
													if (elemento._id !== ubActual.id) {
														dataFilter.push(elemento);
													}
												}
												if (dataFilter.length == 0) {
													alert("No existen ubicaciones dentro de la seleccionada");
												} else {
													let ind = dataFilter[0].tipo.nombre_interno + 's';
													mv.aux.selects[ind] = dataFilter;
												}
											} else {
												let ind = data[0].tipo.nombre_interno + 's';
												mv.aux.selects[ind] = data;
											}
										}
									});
							}
						});
					}

				};

				this.main();


				this.cerrar = function () {
					modal.close(mv.models);
				}
			},
			controllerAs: 'mv',
			size: 'md',
			resolve: {
				proyecto: function () {
					return self.equipo.proyecto._id;
				},
				ubicacionService: function () {
					return ubicacionService;
				},
				scope: function () {
					return self;
				},
				ubicacionActual: function () {
					return self.equipo.ubicacion.ubicacion;
				},
				objetoUbicacionService: function () {
					return objetoUbicacionService;
				},
				tipoUbicacionesService: function () {
					return tipoUbicacionesService;
				}
			}
		});

		modal.result.then((resp) => {
			let auxAnt = this.scope.equipo.ubicacion;

			let newUbicacion = {
				'ubicacion_anterior': auxAnt,
				'ubicacion_nueva': resp,
				'fecha': new Date(),
				'usuario': this.scope.info.get('nombre') + ' ' + this.scope.info.get('apellido')
			};

			this.scope.equipo.historial_ubicaciones.push(newUbicacion);
			this.scope.equipo.ubicacion = resp;

			let dataMov = {
				"_id": this.scope.equipo._id,
				"tipo_equipo": this.scope.equipo.tipo_equipo._id,
				"historial_ubicaciones": this.scope.equipo.historial_ubicaciones,
				"ubicacion_anterior": auxAnt,
				"ubicacion_nueva": resp,
				'fecha': new Date()
			};
			this.inventarioService.registrarMovimiento(dataMov)
				.then((resp, err) => {
					window.location.reload(false);
				}).catch((er) => {
					console.log(er);
				});
		}, (resp) => {
			console.log(resp);
		});
	}

	registrarFalla(tipoFallaService, causaFallaService) {
		let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Registrar Falla</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
						<div class="form-group">
							<label for="" class="col-sm-4">Tipo de falla</label>
							<div class="col-sm-8">
								<select class="form-control"
									ng-model="mv.data.tipo_falla"
									ng-options="ubicacion as ubicacion.nombre for ubicacion in mv.aux.fallas | orderBy:'nombre' "></select>
							</div>
						</div>

						<div class="form-group">
							<label for="" class="col-sm-4">Comentario</label>
							<div class="col-sm-8">
								<input type="text" class="form-control" ng-model="mv.data.comentario">
							</div>
						</div>

						<div class="form-group">
							<label for="" class="col-sm-4">Causa</label>
							<div class="col-sm-8">
								<select class="form-control"
									ng-model="mv.data.causa_falla"
									ng-options="causa as causa.nombre for causa in mv.aux.causa_fallas | orderBy:'nombre' "></select>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="btn btn-success pull-right" ng-click="mv.cerrar()">Aceptar</div>
				</div>
			</div>

		`;

		let self = this.scope;

		var modal = this.uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: '',
			template: templateModal,
			controller: function (tipoFallaService, causaFallaService) {

				var vm = this;
				vm.aux = {};
				vm.data = {
				};

				this.main = function () {
					tipoFallaService.getAll()
						.then((resp, err) => {
							vm.aux.fallas = resp.data.message;
						});
					causaFallaService.getAll()
						.then((resp, err) => {
							vm.aux.causa_fallas = resp.data.message;
						});
				};

				this.main();


				this.cerrar = function () {
					modal.close(vm.data);
				}
			},
			controllerAs: 'mv',
			size: 'md',
			resolve: {
				tipoFallaService: function () {
					return tipoFallaService;
				},
				causaFallaService: function () {
					return causaFallaService;
				}
			}
		});

		modal.result.then((resp) => {
			resp.fecha = new Date();
			resp.usuario = self.info.get('nombre') + ' ' + self.info.get('apellido');
			this.scope.equipo.historial_fallas.push(resp);

			this.inventarioService.update(this.scope.equipo)
				.then((resp, err) => {
					console.log(resp);
					console.log(err);
				});
		}, (resp) => {
			console.log(resp);
		});

	}

	ubicacion(ubicacionService, inventarioService) {
		this.scope.aux = {
			filtros: {}
		};

		ubicacionService.get({ 'tipo.indice': 3 })
			.then((resp, err) => {
				this.scope.aux.areas = resp.data.message;
			});

		this.scope.$watch('aux.filtro.area', (nuevo) => {
			if (nuevo !== undefined) {
				let filtro = {
					'tipo.indice': 2,
					'padre._id': nuevo._id
				};
				ubicacionService.get(filtro)
					.then((resp, err) => {
						this.scope.aux.sectores = resp.data.message;
					});
			}
		});

		this.scope.$watch('aux.filtro.sector', (nuevo) => {
			if (nuevo !== undefined) {
				let filtro = {
					'tipo.indice': 1,
					'padre._id': nuevo._id
				};
				ubicacionService.get(filtro)
					.then((resp, err) => {
						this.scope.aux.ubicaciones = resp.data.message;
					});
			}
		});

		this.scope.$watch('aux.filtro.ubicacion', (nuevo) => {
			if (nuevo !== undefined) {
				let tipo_equipos = nuevo.tipo_equipos;

				let filter = {
					'ubicacion.ubicacion._id': nuevo._id
				};

				inventarioService.getAll(filter)
					.then((resp) => {
						let equipos = resp.data.message;
						let tipos_ocupados = {};

						for (let el in equipos) {
							let element = equipos[el];
							let elId = element.tipo_equipo._id;

							if (typeof tipos_ocupados[elId] == 'undefined') {
								tipos_ocupados[element.tipo_equipo._id] = {
									cantidad: 1,
								};
							} else {
								tipos_ocupados[element.tipo_equipo._id].cantidad += 1;
							}
						}

						for (let el in tipo_equipos) {
							let element = tipo_equipos[el];
							if (tipos_ocupados[element._id]) {
								element.utilizado = tipos_ocupados[element._id].cantidad;
							} else {
								element.utilizado = 0;
							}
						}

						this.scope.aux.tipo_equipos = tipo_equipos;

					});
			}
		});
	}

	ubicacionTipo($routeParams, inventarioService) {
		this.scope.aux = {};

		let _filtro = {
			"ubicacion.ubicacion._id": $routeParams.ubicacion,
			"tipo_equipo._id": $routeParams.tipo_equipo
		};

		inventarioService.getAll(_filtro)
			.then((resp, err) => {
				this.scope.aux.equipos = resp.data.message;
			});

		this.scope.descargarExcel = this.descargarExcel.bind(this, _filtro);
	}

	show(id) {
		this.location.path('/inventario/' + id);
	}

	create(inventarioService,
		ubicacionService,
		tipoEquipoService,
		estadoEquipoService,
		proveedorService,
		Upload,
		marcasService,
		proyectosService,
		tipoOperacionService,
		objetoUbicacionService,
		tipoUbicacionesService
	) {

		let self = this;
		this.scope.$watch("readOnly", function (newVal) {
			if (newVal) {
				self.location.path('/inventario/general');
			}
		});
		this.scope.inAction = false;
		this.scope.equipo = {
			ubicacion: {},
			garantia_cliente: {},
			garantia_fabricante: {},
			atributos: []
		};

		this.scope.aux = {
			garantia_cliente: {},
			garantia_fabricante: {},
			selects: {}
		};

		this.upload = Upload;

		this.scope.tipo_operaciones = [
			"manual",
			"remota"
		];

		this.scope.min = (str) => {
			return str.toLowerCase();
		};

		this.scope.toggle = (primero, segundo) => {
			this.scope.f[primero][segundo] = !this.scope.f[primero][segundo];
		};

		tipoOperacionService.getAll().then((resp, err) => {
			this.scope.aux.tipo_operaciones = resp.data.message;
		});

		tipoEquipoService.getAll().then((resp, err) => {
			if (!err) {
				this.scope.aux.tipo_equipos = resp.data.message;
			}
		});

		estadoEquipoService.getAll().then((resp, err) => {
			if (!err) {
				this.scope.aux.estado_equipos = resp.data.message;
			}
		});

		proveedorService.getAll().then((resp, err) => {
			if (!err) {
				this.scope.aux.proveedores = resp.data.message;
			}
		});

		marcasService.getAll({ "grupo": 'equipo' })
			.then((resp, err) => {
				this.scope.aux.marcas = resp.data.message;
			});

		proyectosService.getAll()
			.then((resp, err) => {
				this.scope.aux.duenos = resp.data.message;
			});

		this.scope.$watch('equipo.proyecto', (nuevo) => {
			if (typeof nuevo !== 'undefined') {
				let filter = {
					proyecto: nuevo._id
				}
				objetoUbicacionService.getAll(filter).then((resp) => {
					this.scope.aux.objeto_ubicaciones = resp.data.message;
				});
			}
		});

		/**/

		this.scope.$watch('equipo.objeto_ubicacion', (nuevo) => {
			if (nuevo !== undefined) {
				this.scope.aux.flag_receptor = nuevo.flag_receptor;

				let filter = {
					"objeto_ubicacion._id": nuevo._id
				};

				tipoUbicacionesService.getAll(filter)
					.then((resp) => {
						this.scope.aux.tipo_ubicaciones = resp.data.message;
						// esta es la primera llamada y es manual
						// el indice 50 es el padre de todos los tipos
						let filter = {
							'tipo.indice': 50,
							'objeto_ubicacion._id': nuevo._id
						};
						ubicacionService.getAll(filter).
							then((resp, err) => {
								if (!err) {
									if (resp.data.message.length == 0) {
										alert('La estructura de este objeto no esta definida');
									}
									let index = this.scope.aux.tipo_ubicaciones[0].nombre_interno + 's';
									this.scope.aux.selects[index] = resp.data.message;
								}
							});
						ubicaciones()
					});
			}
		});

		var ubicaciones = () => {
			let data = this.scope.aux.tipo_ubicaciones;
			// este restringe el tipo de equipo en la ubicacion
			let arCollection = ['equipo.tipo_equipo'];
			for (var el in data) {
				let aux = data[el];

				let str = 'equipo.ubicacion.' + aux.nombre_interno;
				if (aux.flag_equipos) {
					arCollection.push(str);
				}
				// le agregamos el watch a los inputs
				this.scope.$watch(str, (nuevo) => {
					if (nuevo !== undefined && nuevo !== null && !nuevo.tipo.flag_equipos) {
						var filter = {
							"tipo.indice": nuevo.tipo.indice - 1,
							"padre._id": nuevo._id
						}

						// si es penultimo tenemos que hacer las siguientes valid.
						if (aux.flag_penultimo && !this.scope.equipo.tipo_equipo.sub_parte) {
							filter.$or = [
								{
									"tipo_equipo._id": this.scope.equipo.tipo_equipo._id,
									"tipo_equipo.flag_disponible": true
									// $elemMatch: {
									// _id : this.scope.equipo.tipo_equipo._id,
									// disponible: true
									// {
									// 	$gt: 0
									// }
									// }
									// }
								},
								{
									"objeto_ubicacion.flag_receptor": true
								}
							]
						}

						if (aux.flag_penultimo && this.scope.equipo.tipo_equipo.sub_parte) {
							filter.$or = [
								{
									"objeto_ubicacion.flag_receptor": this.scope.aux.flag_receptor
								}
							];
							// {
							// 	"tipo_equipo._id" = this.scope.equipo.tipo_equipo.padre[0]._id
							// },
						}

						let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

						ubicacionService.getAll(param)
							.then((resp) => {
								let data = resp.data.message;
								if (data.length == 0) {
									alert("No existen ubicaciones dentro de la seleccionada");
								} else {
									let ind = data[0].tipo.nombre_interno + 's';
									this.scope.aux.selects[ind] = data;
								}
							});
					}
				});
			}

			this.scope.$watchGroup(arCollection, (newValues, oldValues) => {
				let todoOk = true;
				for (var el in newValues) {
					if (!newValues[el]) {
						todoOk = false;
					}
				}

				if (todoOk && this.scope.equipo.tipo_equipo.sub_parte && !this.scope.aux.flag_receptor) {
					let padreIds = [];

					for (var i = 0; i < this.scope.equipo.tipo_equipo.padre.length; i++) {
						padreIds.push(this.scope.equipo.tipo_equipo.padre[i]._id);
					}

					let ubicacionAux = this.scope.equipo.ubicacion;
					let keyMin = '';
					let indMin = 50;
					let idMin = '';
					for (var el in ubicacionAux) {
						let element = ubicacionAux[el];
						if (element.tipo.indice < indMin) {
							indMin = element.tipo.indice;
							keyMin = el;
						}
					}
					idMin = ubicacionAux[keyMin]._id;

					let proyecto = this.scope.equipo.proyecto._id;
					let filter = {
						'ubicacion.ubicacion._id': idMin,
						'tipo_equipo.sub_parte': false,
						'proyecto._id': proyecto,
						'tipo_equipo._id': {
							"$in": padreIds
						}
					};

					inventarioService.getAll(JSON.stringify(filter))
						.then((resp, errp) => {
							if (resp.data.message.length == 0) {
								alert("No existen equipos disponibles en esta ubicación");
							} else {
								this.scope.aux.equipos_padre = resp.data.message;
							}
						});
				}
			});

		};

		// let arCollection = ['equipo.tipo_equipo', 'equipo.ubicacion.ubicacion'];
		this.scope.uploadFiles = ($file, $invalidFiles) => {
			this.scope.imagen = $file;
		};

		this.scope.guardar = () => {
			if (!this.scope.inAction) {
				this.scope.inAction = true;
				this.upload.upload({
					url: this.baseUrl + '/api/inventario',
					data: {
						imagen: this.scope.imagen,
						equipo: angular.toJson(this.scope.equipo)
					}
				}).then((resp) => {
					this.toastr.success('Equipo creado correctamente!', 'Success!', {
						timeOut: 2000,
						closeButton: true
					});
					this.location.path('/inventario/' + resp.data.message);
				}).catch((er) => {
					this.scope.inAction = false;
					this.toastr.error(er.data.error, 'Error', {
						timeOut: 2000,
						closeButton: true
					});
					console.log(er);
				});
			}
		};

		this.scope.addAtributte = this.addAtributte.bind(this, inventarioService);
	}

	addAtributte(inventarioService) {
		if (!this.scope.inAction) {

			if (this.scope.aux.atributo_nombre === '' ||
				this.scope.aux.atributo_valor === '') {
				return false;
			}

			let data = {
				nombre: this.scope.aux.atributo_nombre,
				valor: this.scope.aux.atributo_valor
			};

			this.scope.equipo.atributos.push(data);
			this.scope.aux.atributo_nombre = '';
			this.scope.aux.atributo_valor = '';

			let info = {
				_id: this.scope.equipo._id,
				atributos: this.scope.equipo.atributos
			};
			this.scope.inAction = true;
			inventarioService.update(info)
				.then((resp, err) => {
					this.scope.inAction = false;
					console.log(resp.data.message);
				});
		}
	}

	addFile(Upload) {
		Upload.upload({
			url: this.baseUrl + '/api/inventario/files',
			data: {
				_id: this.scope.equipo._id,
				archivo: this.scope.archivo
			}
		}).then((res, err) => {
			this.toastr.success('Archivo agregado correctamente!', 'Success!', {
				timeOut: 2000,
				closeButton: true
			});
			this.scope.route.reload();
		});
	}

	carga(Upload) {
		this.scope.titulo = "Carga Equipos";

		this.scope.modal_carga = this.modal_carga.bind(this, Upload);
	}

	modal_carga(Upload) {
		let templateModal = `
				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header">
						<h4 style="text-align:center;" class="modal-title">Selecciona el archivo a subir</h4>
					</div>
					<div class="modal-body">
					<div class="form-group">
						<label class="control-label col-md-5 col-sm-5 col-xs-12" for="first-name">Archivo
						</label>
						<div class="col-md-7 col-sm-7 col-xs-12">
							<input
								type="file"
								ngf-select="mv.upFile($file, $invalidFiles)"
								accept="application/*"
								ngf-max-height="1000"
								ngf-max-size="1MB">
						</div>
					</div>
				    </div>
				    <div class="modal-footer">
						<div class="btn btn-success pull-right" ng-click="mv.cerrar()">Agregar</div>
				    </div>
				</div>
			`;

		var modalInstance = this.uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			template: templateModal,
			controller: function () {
				this.aux = {};
				this.cerrar = function (input) {
					modalInstance.close(this.archivo);
				}

				this.upFile = function ($file, $invalidFiles) {
					this.archivo = $file;
				}
			},
			controllerAs: 'mv',
			size: 'md'
		});

		modalInstance.result.then((data) => {

			Upload.upload({
				url: this.baseUrl + '/api/inventario/carga',
				data: {
					archivo: data
				}
			}).then((res, err) => {
				if (err) return false;

				let buenos = res.data.buenos.map((e) => {
					let aux = e.split(',');

					let r = {
						id: aux[0],
						tipo_equipo: aux[1]
					}

					return r;
				});

				let malos = res.data.malos.map((e) => {
					let aux = e.split(',');

					let r = {
						id: aux[0],
						tipo_equipo: aux[1]
					}

					return r;
				});


				this.scope.tablas = {
					correctos: buenos,
					erroneos: malos
				}
			});

		}, () => {
			console.log('Modal dismissed at: ' + new Date());
		});
	}

	handleDisplayFilters() {
		this.scope.displayFilters = !this.scope.displayFilters;
	}

}



// WEBPACK FOOTER //
// ./app/js/controllers/inventario/inventario.js